import { groupBy, mapValues, sum } from 'lodash-es';
import { useMemo } from 'react';
import { ListingWithComp } from 'src/tiles/ListingTilesV2';
import { SectionInfo } from 'src/WebApiController';

export const useSectionAndZoneListingCounts = (
  inventory: ListingWithComp[],
  sections: SectionInfo[]
) => {
  const sectionListings = useMemo(() => {
    return groupBy(
      inventory.filter(
        (listing) => !listing.isCompListing && !!listing.seating.section
      ),
      (l) => l.seating?.section
    );
  }, [inventory]);
  const sanitizedSections = useMemo(() => {
    const inventorySections = Object.keys(sectionListings).filter(
      (s: string | undefined): s is string => !!s
    );

    return sections.filter((section) =>
      inventorySections.includes(section.name)
    );
  }, [sectionListings, sections]);

  const zoneSections = useMemo(() => {
    return mapValues(
      groupBy(
        sanitizedSections,
        (s) => s.rows?.find((r) => r.tktClass?.name)?.tktClass?.name
      ),
      (ss) => ss.map((s) => s.name)
    );
  }, [sanitizedSections]);

  const sectionListingCount = useMemo(() => {
    return mapValues(sectionListings, (listings) => listings.length ?? 0);
  }, [sectionListings]);

  const zoneListingCount = useMemo(() => {
    return mapValues(zoneSections, (sections) =>
      sum(sections.map((s) => sectionListingCount[s] ?? 0))
    );
  }, [sectionListingCount, zoneSections]);

  return {
    zoneSections,
    sectionListingCount,
    zoneListingCount,
  };
};
